
import { useState } from 'react';

export default function RegionComparison() {
  const [regionA, setRegionA] = useState('서울특별시 강남구');
  const [regionB, setRegionB] = useState('경기도 성남시');

  const regions = [
    '서울특별시 강남구',
    '서울특별시 서초구',
    '서울특별시 송파구',
    '경기도 성남시',
    '경기도 수원시',
    '경기도 고양시',
    '부산광역시 해운대구',
    '대구광역시 수성구'
  ];

  const comparisonData = {
    '서울특별시 강남구': {
      totalScore: 95,
      grade: 'A',
      categories: [
        { name: '법규환경', score: 94, grade: 'A' },
        { name: '민원규제', score: 92, grade: 'A' },
        { name: '경제활동친화성', score: 96, grade: 'A' },
        { name: '행정절차', score: 93, grade: 'A' },
        { name: '인허가', score: 95, grade: 'A' },
        { name: '세무환경', score: 97, grade: 'A' }
      ],
      strengths: ['우수한 경제활동 환경', '빠른 행정처리', '투명한 세무환경'],
      weaknesses: ['높은 임대료', '경쟁 심화']
    },
    '경기도 성남시': {
      totalScore: 90,
      grade: 'A',
      categories: [
        { name: '법규환경', score: 88, grade: 'B' },
        { name: '민원규제', score: 89, grade: 'B' },
        { name: '경제활동친화성', score: 92, grade: 'A' },
        { name: '행정절차', score: 87, grade: 'B' },
        { name: '인허가', score: 91, grade: 'A' },
        { name: '세무환경', score: 93, grade: 'A' }
      ],
      strengths: ['우수한 창업 지원', '합리적인 임대료', '좋은 접근성'],
      weaknesses: ['일부 행정절차 개선 필요']
    }
  };

  const dataA = comparisonData[regionA as keyof typeof comparisonData];
  const dataB = comparisonData[regionB as keyof typeof comparisonData];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4 sm:mb-6 flex items-center">
        <i className="ri-git-compare-line text-blue-600 mr-2"></i>
        지역 비교 분석 (A vs B)
      </h3>

      {/* 지역 선택 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">A 지역</label>
          <select
            value={regionA}
            onChange={(e) => setRegionA(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-xs sm:text-sm pr-8"
          >
            {regions.map(region => (
              <option key={region} value={region}>{region}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">B 지역</label>
          <select
            value={regionB}
            onChange={(e) => setRegionB(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-xs sm:text-sm pr-8"
          >
            {regions.map(region => (
              <option key={region} value={region}>{region}</option>
            ))}
          </select>
        </div>
      </div>

      {/* 종합 점수 비교 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div className="bg-blue-50 p-4 sm:p-6 rounded-lg">
          <div className="text-xs sm:text-sm text-blue-600 font-medium mb-2">A 지역 종합 점수</div>
          <div className="text-2xl sm:text-3xl font-bold text-blue-900 mb-1">{dataA.totalScore}점</div>
          <div className="text-xs sm:text-sm text-blue-700">{dataA.grade}등급</div>
        </div>
        <div className="bg-green-50 p-4 sm:p-6 rounded-lg">
          <div className="text-xs sm:text-sm text-green-600 font-medium mb-2">B 지역 종합 점수</div>
          <div className="text-2xl sm:text-3xl font-bold text-green-900 mb-1">{dataB.totalScore}점</div>
          <div className="text-xs sm:text-sm text-green-700">{dataB.grade}등급</div>
        </div>
      </div>

      {/* 항목별 비교 */}
      <div className="mb-4 sm:mb-6">
        <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">항목별 점수 비교</h4>
        <div className="overflow-x-auto -mx-3 sm:mx-0">
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-2 sm:py-3 px-2 sm:px-4 font-medium text-gray-700 text-xs sm:text-sm">평가항목</th>
                <th className="text-center py-2 sm:py-3 px-2 sm:px-4 font-medium text-blue-700 text-xs sm:text-sm">A 지역</th>
                <th className="text-center py-2 sm:py-3 px-2 sm:px-4 font-medium text-green-700 text-xs sm:text-sm">B 지역</th>
                <th className="text-center py-2 sm:py-3 px-2 sm:px-4 font-medium text-gray-700 text-xs sm:text-sm">차이</th>
              </tr>
            </thead>
            <tbody>
              {dataA.categories.map((categoryA, index) => {
                const categoryB = dataB.categories[index];
                const diff = categoryA.score - categoryB.score;
                return (
                  <tr key={categoryA.name} className="border-b border-gray-100">
                    <td className="py-2 sm:py-3 px-2 sm:px-4 text-xs sm:text-sm text-gray-900">{categoryA.name}</td>
                    <td className="py-2 sm:py-3 px-2 sm:px-4 text-center">
                      <div className="flex flex-col items-center">
                        <span className="text-xs sm:text-sm font-medium text-gray-900">{categoryA.score}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          categoryA.grade === 'A' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                        }`}>
                          {categoryA.grade}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 sm:py-3 px-2 sm:px-4 text-center">
                      <div className="flex flex-col items-center">
                        <span className="text-xs sm:text-sm font-medium text-gray-900">{categoryB.score}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          categoryB.grade === 'A' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                        }`}>
                          {categoryB.grade}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 sm:py-3 px-2 sm:px-4 text-center">
                      <span className={`text-xs sm:text-sm font-medium ${
                        diff > 0 ? 'text-blue-600' : diff < 0 ? 'text-green-600' : 'text-gray-600'
                      }`}>
                        {diff > 0 ? `A +${diff}` : diff < 0 ? `B +${Math.abs(diff)}` : '동일'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* 강점/약점 비교 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <div>
          <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3">A 지역 특성</h4>
          <div className="space-y-2">
            <div>
              <div className="text-xs font-medium text-green-700 mb-1">강점</div>
              <ul className="space-y-1">
                {dataA.strengths.map((strength, index) => (
                  <li key={index} className="text-xs text-gray-600 flex items-start">
                    <i className="ri-check-line text-green-500 mr-1 mt-0.5 flex-shrink-0"></i>
                    <span>{strength}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-xs font-medium text-red-700 mb-1">개선점</div>
              <ul className="space-y-1">
                {dataA.weaknesses.map((weakness, index) => (
                  <li key={index} className="text-xs text-gray-600 flex items-start">
                    <i className="ri-close-line text-red-500 mr-1 mt-0.5 flex-shrink-0"></i>
                    <span>{weakness}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div>
          <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3">B 지역 특성</h4>
          <div className="space-y-2">
            <div>
              <div className="text-xs font-medium text-green-700 mb-1">강점</div>
              <ul className="space-y-1">
                {dataB.strengths.map((strength, index) => (
                  <li key={index} className="text-xs text-gray-600 flex items-start">
                    <i className="ri-check-line text-green-500 mr-1 mt-0.5 flex-shrink-0"></i>
                    <span>{strength}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-xs font-medium text-red-700 mb-1">개선점</div>
              <ul className="space-y-1">
                {dataB.weaknesses.map((weakness, index) => (
                  <li key={index} className="text-xs text-gray-600 flex items-start">
                    <i className="ri-close-line text-red-500 mr-1 mt-0.5 flex-shrink-0"></i>
                    <span>{weakness}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
